import { makeStyles } from '@mui/styles';
import { FontWeight, Colors } from '../../../../assets/styles';

const useStyles = makeStyles(({ typography }: any) => {
  const pxToRem = (px: number): string => `${px / 16}rem`;

  return {
    container: {
      position: 'relative',
      width: '100%',
      minHeight: pxToRem(500),
    },
    controlsContainer: {
      display: 'flex',
      justifyContent: 'end',
    },
    exportButton: {
      padding: '0px !important',
      height: '38px',
      width: '270px',
      border: `1px solid ${Colors.Gray2} !important`,
      alignContent: 'end',
      backgroundColor: `${Colors.White} !important`,
      color: `${Colors.Gray10} !important`,
      marginBottom: '20px !important',
      '&:hover': {
        color: Colors.Gray4,
      },
    },
    table: {
      width: '100%',
      backgroundColor: Colors.White,
      border: `1px solid ${Colors.Gray1}`,
       marginBottom: '24px !important',
    },
    moreBtn: {
      fontSize: 14,
      fontWeight: FontWeight.Bold,
      color: Colors.Blue1,
      marginBottom: 30,
    },
    noResults: {
      textAlign: 'center',
      fontSize: pxToRem(22),
      paddingTop: pxToRem(130),
    },
    filterButton: {
      marginLeft: pxToRem(-15),
      marginRight: pxToRem(5),
    },
    activeFilter: {
      color: Colors.Blue1,
    },
    headersMenuOptionsButton: {
      color: Colors.Blue1,
    },
  };
});

// Table cell styles
export const useTableCellStyles = makeStyles(() => ({
  root: {
    paddingLeft: 24,
  },
  head: {
    fontWeight: FontWeight.Bold,
    color: Colors.Gray,
    fontSize: 15,
    paddingTop: 8,
    paddingBottom: 8,
  },
  body: {
    color: Colors.Gray,
    fontSize: 15,
  },
}));

export default useStyles;